export const SET_PRESERVATION_PROPORTIONS = "SET_PRESERVATION_PROPORTIONS";

export const SET_ACTIVE_SOCIAL_NETWORKS = "SET_ACTIVE_SOCIAL_NETWORKS";

export const SERVICE_SET_CROP_DIMENSIONS = "SERVICE_SET_CROP_DIMENSIONS";
export const SERVICE_SET_CROP_POSITION = "SERVICE_SET_CROP_POSITION";


